import { now as serverNow } from '~/models/clock'

/**
 * 入稿済みデータのダウンロードファイル名を組み立てる
 * (uploads/common.md §6「ダウンロードファイル名の命名規則」:
 * `{データ種別名}_{YYYYMMDD}.csv`、ダウンロード実行日)。データ種別名は呼び出し側が
 * 表示言語に応じて渡す (日本語表示は日本語データ種別名、英語表示は英語データ種別名。
 * AC-SPS-030。例: `cisContractCsvExportFileName`)。
 *
 * 48点データは全量ダウンロードを持たない (一覧の「ダウンロード」は業務画面へ遷移する、
 * AC-DUC-028 ※)。
 */
export function commonUploadCsvFileName(
  dataTypeName: string,
  today: Date = serverNow(),
): string {
  const yyyy = today.getFullYear()
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const dd = String(today.getDate()).padStart(2, '0')
  return `${dataTypeName}_${yyyy}${mm}${dd}.csv`
}
